import { forwardRef } from 'react';
import { IMaskInput } from 'react-imask';
import {
  e164ToNanpMaskDigits,
  maskedNanpInputToE164,
} from './phoneNumberMask.util';

export interface CustomProps {
  onChange: (event: { target: { name: string; value: string } }) => void;
  name: string;
  value: string;
  onBlur: (value: string) => void;
}

const PhoneNumberMask = forwardRef<HTMLElement, CustomProps>(function PhoneMask(
  props,
  _ref
) {
  const { onChange, onBlur, ...other } = props;
  const formattedValue = props.value ? e164ToNanpMaskDigits(props.value) : '';
  return (
    <IMaskInput
      {...other}
      mask="(000) 000-0000"
      unmask
      value={formattedValue}
      onBlur={() => {
        onChange({ target: { name: props.name, value: props.value } });
        if (onBlur) onBlur(props.value);
      }}
      onAccept={(rawValue: string) => {
        const updatedValue = maskedNanpInputToE164(rawValue);
        if (props.value !== updatedValue) {
          onChange({ target: { name: props.name, value: updatedValue } });
        }
      }}
      overwrite
    />
  );
});

export default PhoneNumberMask;
